<template>
    <div id="Faqhelp">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div class="web-right-sidebar">
            <div class="right-asset-tab-list faq-right-sidebar">
                <div class="faq-search-input p-3">
                    <input type="text" id="myInput" class="form-control" @input="filterFunction()" placeholder="Search for Module..">
                </div>
                <div class="faq-subject-list p-3">
                    <h5> Help Topics </h5>
                    <ul id="myUL">
                       <template v-if="moduleArr.length > 0">
                        <template v-for="(mod,modKey) in moduleArr">
                            <li :key="modKey"> <a href="javascript:void(0)" v-on:click="getQueriesByModule(mod.value)"> {{mod.text}} </a> </li>
                        </template>
                    </template>
                    </ul>
                </div>
            </div>
        </div>
        <div id="page-content-wrapper" class="admin-content-area left-asset-detail-section faq-left-section">
            <template v-if="cantAccessPage === true">
                <div class="page-name asset-view-page-name">FAQ</div>
                <div class="container-fluid">
                    <div id="customer-detail" class="admin-page-content faq-page" v-show="activetab == 1">
                        <section class="internal-container border-top-table-fl">
                            <div class="row">
                                <div class="col-md-8">
                                    <input type="text" id="myInput" class="form-control" v-model="queryString" placeholder="Search for Question..">
                                </div>
                                <div class="col-md-4">
                                    <button type="submit" class="btn btn-primary" v-on:click.prevent="getQueriesByModule(0)">
                                        <i class="fp-save"> </i> Go
                                    </button>
                                </div>
                            </div>
                            <p>&nbsp;</p><p>&nbsp;</p>
                            <template v-if="faqQuery.length > 0">
                                <template v-for="(query,qKey) in faqQuery">   
                                    <div :key="qKey">
                                        <div class="faq-questions-list" v-if="!showAnswer">
                                            <p> <a href="javascript:void(0)" v-on:click="addId(query.id)">{{query.question}}</a> </p>
                                        </div>
                                        <a href="javascript:void(0)" v-if="showAnswer && queryId == query.id" v-on:click="showAnswer = false" class="faq-back-btn"> <i class="fp-back" style="font-size:14px;"></i> Back </a>
                                        <div v-if="showAnswer && queryId == query.id" class="faq-answer-section clear">
                                            <div class="faq-question-section">
                                                {{query.question}}
                                            </div>
                                            <div class="faq-answer-section">
                                            - {{query.answer}}
                                            </div>
                                            <div v-if="!ratingUpdatedArr.includes(query.id)" class="helpful-link-section mt-4">
                                                <p> Was This Useful: </p>
                                                <a href="javascript:void(0)" class="btn btn-tertiary" v-on:click.prevent="updateFeedback(query.id,'yes')"><i class="fp-thumbs-up"></i> Yes</a>
                                                <a href="javascript:void(0)" class="btn btn-tertiary" v-on:click.prevent="updateFeedback(query.id,'no')"><i class="fp-thumbs-down"></i> No</a>
                                                <p>&nbsp;</p>
                                            </div>
                                            <div v-else>
                                                <p class="alert-success p-2">Thank You For Your Feedback.</p>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </template>
                            <template v-else>
                                No Record Found.
                            </template>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
    import Vue from "vue";
    
    
    import {commonMixins} from '../mixins/commonMixins';
    
    
    export default {
        name: "Faqhelp",
        metaInfo() {
            return {title: "FAQ Help | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins],
        data: () => ({
            loading:false,
            cantAccessPage: "",
            permissions: [],
            activetab: 1,
            moduleArr:[],
            faqQuery:[],
            queryString:'',
            ratingUpdatedArr:[],
            showAnswer:false,
            queryId:0
        }),
        watch: {

            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'view_customer') {
                            self.cantAccessPage = true;
                        }
                    }
                }
            },
        },
        created: function() {

        },
        mounted: function() {
            var self = this;
            // var path =  process.env.ROOT_API;
            self.getPermissions();
            self.getModules();
        },
        methods: {
            getModules() {
                var self = this;
                self.loading = true;
                self.firstLoad = 1;
                $.ajax({
                    // url: process.env.ROOT_API + "/get_modules_by_package",
                    url: process.env.ROOT_API + "/get-modules",
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:{
                    flag:'all' 
                    },
                    success: function (data) {
                        self.loading = false;
                        self.moduleArr = data.content;
                        console.log(data);
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'faq-help-get-modules')
                    }
                });
            },

            filterFunction: function() {
                // Declare variables
                var input, filter, ul, li, a, i, txtValue;
                input = document.getElementById('myInput');
                filter = input.value.toUpperCase();
                ul = document.getElementById("myUL");
                li = ul.getElementsByTagName('li');
                
                var notFoundCount = 0;
                //remove no record found element
                var removeElement = document.getElementById("noRecordFound");
                if (removeElement != undefined && removeElement != null) {
                    removeElement.parentNode.removeChild(removeElement);
                }
                    // Loop through all list items, and hide those who don't match the search query
                for (i = 0; i < li.length; i++) {
                    a = li[i].getElementsByTagName("a")[0];
                    txtValue = a.textContent || a.innerText;
                    if (txtValue != "No Record Found.") {
                        if (txtValue.toUpperCase().indexOf(filter) > -1) {
                            li[i].style.display = "";
                        } else {
                            li[i].style.display = "none";
                            notFoundCount++;
                        }
                    }
                }
                //append no record found element
                if (notFoundCount == li.length) {
                    var notFoundElement = document.getElementById("noRecordFound");
                    var notFound = document.createElement("li");
                    var notFoundLink = document.createElement("a");
                    notFoundLink.href = "#";
                    notFoundLink.target = "_self";
                    notFoundLink.innerHTML = "No Record Found.";
                    notFound.setAttribute("id", "noRecordFound");
                    notFound.appendChild(notFoundLink);
                    ul.appendChild(notFound);
                }
            },
            getQueriesByModule: function(moduleId){
                var self = this;
                self.showAnswer = false;

                $.ajax({
                    url: process.env.ROOT_API + "/get-faq",
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:{
                    module_id:moduleId,
                    string:self.queryString
                    },
                    success: function (data) {
                        self.loading = false;
                        self.faqQuery = data.content;
                        console.log(data);
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'faq-help-get-querries-modules')
                    }
                });
            },
            updateFeedback: function(id,flag){
                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/update/rating",
                    type: "POST",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:{
                    id:id,
                    flag:flag 
                    },
                    success: function (data) {
                        self.loading = false;
                        self.ratingUpdatedArr.push(id);
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'faq-help-update-ratings')
                    }
                });
            },
            addId:function(id){

                var self = this;

                self.showAnswer = true;
                self.queryId = id;

            }
        }
    };

</script>




// WEBPACK FOOTER //
// src/components/FAQHelp.vue